/**
 * Panel.jsx
 * Created by Mike Bray on 8/3/17.
 */

import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
    children: PropTypes.node
};

const Panel = ({ children }) => (
    <div>{children}</div>
);

Panel.propTypes = propTypes;

export default Panel;
